<template>
  <div class="metafield-edit-color">
    <p class="metafield__title">{{ field.label }}</p>
    <ColorPicker :value="value || '#000000'" :disableAlpha="true" @input="onInput" />
    <TypographyInputHint v-if="hint">{{ hint }}</TypographyInputHint>
  </div>
</template>

<script>
import { Chrome } from 'vue-color'
import { forSingleMetafield } from '@/mixins/metafields-changed-detection.mixin'

export default {
  mixins: [ forSingleMetafield(true) ],
  components: {
    ColorPicker: Chrome
  },
  props: {
    value: { 
      type: String,
      default: '#000000'
    },
    field: Object,
    hint: String
  },
  methods: {
    onInput (val) {
      this.$emit('input', val.hex)
    }
  },
  mounted () {
    this.$emit('input', this.value || '#000000')
  }
}
</script>

<style lang="scss">
  @import './src/assets/styles/mixins.scss';

  .metafield-edit-color {
    display: block;

    .metafield__title {
      margin-bottom: 13px;
    }

    .vc-chrome {
      box-shadow: none;
    }

    .vc-chrome-fields-wrap {
      // display: none;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/metafields-edit/metafields/MetafieldEditColor.vue